import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { HomeWork } from "@material-ui/icons/";
import Divider from "@material-ui/core/Divider";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Animated } from "react-animated-css";
import Tooltip from "@material-ui/core/Tooltip";

//import { UserContext } from "../components/UserContext";

const useStyles = makeStyles((theme) => ({
  typographyHeader: {
    color: "#FFFFFF",
    fontFamily: '"Helvetica Neue"',
  },
  typographyContent: {
    color: "#000",
    marginTop: "60px",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
  },

  buttoHome: {
    marginTop: "5%",
  },

  dividerBottom: {
    marginBottom: "5%",
  },
  icon: {
    color: "#000",
  },
  buttonSubmit: {
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    marginTop: "6%",
    color: "#000",
    background: "#F7F00B",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
    "&:hover": {
      backgroundColor: "#000",
      color: "#F7F00B",
    },
  },
  containerItems: {
    overflow: "hidden",
  },
  textBotom: {
    padding: "5px",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    textDecoration: "none",
    color: "#000",
  },
}));

export default function Home(props) {
  const classes = useStyles();
  const [alert] = useState({
    loggedIn: localStorage.getItem("token") === null ? false : true,
  });

  const [openBackdropHome, setOpenBackdropHome] = useState(false);
  const [routeHome, setRouteHome] = useState("");

  //const { user } = useContext(UserContext)

  useEffect(() => {
    props.callbackRoutaHome(routeHome);
    setOpenBackdropHome(routeHome);
  }, [routeHome]);

  const handleClick = (prop) => (event) => {
    event.preventDefault();
    setOpenBackdropHome(true);
    setTimeout(() => {
      setRouteHome(prop);
      props.callbackRoutaHome(routeHome);
      setOpenBackdropHome(false);
    }, 800);
  };

  if (!alert.loggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Typography
        align="left"
        variant="subtitle1"
        className={classes.textBotom}
      >
        <HomeWork className={classes.icon} /> Panel de control
      </Typography>
      <Divider className={classes.dividerBottom} />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} className={classes.containerItems}>
          <center>
            <Animated
              animationIn="slideInLeft"
              animationInDuration={2000}
              animationOutDuration={1000}
              isVisible={true}
            >
              <img
                src="../../images/undraw_going_offline_ihag.png"
                alt="Publico"
                style={{ width: "300px", height: "400px", objectFit: "cover" }}
              />
              <Typography
                className={classes.typographyContent}
                gutterBottom
                variant="h6"
              ></Typography>
            </Animated>
          </center>
        </Grid>

        <Grid item xs={12} md={6} className={classes.containerItems}>
          <Animated
            animationIn="slideInRight"
            animationInDuration={2000}
            animationOutDuration={1000}
            isVisible={true}
          >
            <Typography
              align="left"
              variant="h5"
              className={classes.typographyContent}
            >
              Bienvenid@,
              <div
                style={{
                  marginTop: "10px",
                  color: "#F7F00B",
                  textShadow: "1px 1px 1px #232321",
                  fontSize: "42px",
                }}
              >
                {localStorage.getItem("perfil") === "2"
                  ? localStorage.getItem("store_name")
                  : localStorage.getItem("user_fullname")}
              </div>
            </Typography>

            <Grid container spacing={3} className={classes.buttoHome}>
              {localStorage.getItem("perfil") === "2" ? (
                <Fragment>
                  <Grid item xs={12} md={4}>
                    <Button
                      variant="contained"
                      size="large"
                      className={classes.buttonSubmit}
                      onClick={handleClick("Productos")}
                    >
                      Productos
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      variant="contained"
                      size="large"
                      className={classes.buttonSubmit}
                      onClick={handleClick("Miregistros")}
                    >
                      Registro
                    </Button>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    {" "}
                    <Divider />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Tooltip title="Goubi en Android">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.aplios.goubidistribuidor"
                        target="_blank"
                      >
                        <img
                          src="../../images/android.png"
                          alt="android"
                          style={{
                            width: "45px",
                            objectFit: "cover",
                            borderRadius: "10px",
                            margin: "10px",
                          }}
                        />
                      </a>
                    </Tooltip>

                    {/*
              <Tooltip title="Goubi en IOS">
                <a href="" target="_blank"> 
              <img
                src="../../images/ios.png"
                alt="ios"
                style={{ width: "45px",
                objectFit: "cover",
                borderRadius: "10px", margin: "10px 10px 7px 10px" }}
              />
              </a>
              </Tooltip>
                    */}
                  </Grid>
                </Fragment>
              ) : (
                <Grid item xs={12} md={4}>
                  <Button
                    variant="contained"
                    size="large"
                    className={classes.buttonSubmit}
                    onClick={handleClick("MiregistrosDelivery")}
                  >
                    Registro
                  </Button>
                </Grid>
              )}
            </Grid>
          </Animated>
        </Grid>
      </Grid>
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdropHome}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
}
